import { planTypes } from '@/common/constants';
import { pageConfig } from '@/common/service/page-config';
import { EVENT_SAAS_ADDITIONAL_CO_EDITOR, EVENT_SAAS_CORE_ADDITIONAL_CO_EDITOR } from '@/common/constants';
import { handlePreData } from '@/plans/ADDITIONAL_HOST/pre';

export const AdditionalHostCategories = [
  EVENT_SAAS_ADDITIONAL_CO_EDITOR, // zoom events additional co editor
  EVENT_SAAS_CORE_ADDITIONAL_CO_EDITOR, // zoom sessions additional co editor
];

export const CATEGORY = AdditionalHostCategories.includes(pageConfig.editConfig.category)
  ? pageConfig.editConfig.category
  : {
      [planTypes.EVENT_SAAS]: EVENT_SAAS_ADDITIONAL_CO_EDITOR,
      [planTypes.EVENT_SAAS_CORE]: EVENT_SAAS_CORE_ADDITIONAL_CO_EDITOR,
    }[pageConfig.editConfig.planType];

export const Title = {
  [EVENT_SAAS_ADDITIONAL_CO_EDITOR]: 'billing.events.addon.ze_co_editors_title',
  [EVENT_SAAS_CORE_ADDITIONAL_CO_EDITOR]: 'billing.events.addon.zs_co_editors_title',
}[CATEGORY];

export default handlePreData(
  AdditionalHostCategories, 
  CATEGORY, 
  planTypes.ADDITIONAL_CO_EDITOR, 
  'billing.planform.title.additional_co_editor', 
  Title,
);
